import {
  Button,
  Form,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ListActionButton,
  ModalCustom,
  Search,
} from "components/common";
import React, { useEffect, useRef, useState } from "react";
import { discountsColumns, discountsInfo } from "./config";
import Icons from "assets/icons";
import { discountsService } from "api";
import "./Discounts.scss";
import Notification from "components/common/notification/notification";
import ListDiscounts from "./ListDiscounts/ListDiscounts";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import { ColumnProps } from "types/models";
import {
  clearEmployee,
  setAdd,
  setCCKM,
  setEdit,
  setEmployeeMode,
  setIdKM,
} from "redux/reducer/employee";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey } from "redux/reducer/common";
import { FORMAT_TIME, tabKeys } from "types/enums";
import { CCKM_MODE } from "types/enums/employee";
import { formatDateToString } from "helper/common";
import dayjs from "dayjs";
//import FormAdd from "./FormAdd/FormAdd";

const Discounts = ({ setIsTabDisabled, setIsTabDisabledCT }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [form] = Form.useForm();
  const [discounts, setDiscounts] = useState<any>(null);
  const listRef = useRef<any>();
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    ngayBatDau: dayjs().format(FORMAT_TIME.invertDayFull),
    ngayKetThuc: dayjs().format(FORMAT_TIME.invertDayFull),
  });
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useAppDispatch();
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  // const fetchListDiscounts = async (params) => {
  //   try {
  //     setLoading(true);
  //     let response = await discountsService.searchKM(params);
  //     // console.log(response);
  //     setDiscounts(response);
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //   }
  // };
  const getList = async () => {
    setLoading(true);
    try {
      // const params = { page, limit };
      const response = await discountsService.searchKM(params);
      setDiscounts(response);
      setLoading(false);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi load danh sách chương trình khuyến mãi"
      );
      setLoading(false);
    }
  };
  const activeTab = useAppSelector((e) => e.common.activeTab);
  useEffect(() => {
    getList();
  }, [params, activeTab]);
  const handelOnExport = async () => {
    setLoading(true);
    try {
      const response = await discountsService
        .getExportKM(params)
        .then((res) => {
          // console.log("res export", res);
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `Báo cáo chương trình ưu đãi.xlsx`;
          link.click();
          setLoading(false);
          Notification("success", "Đã xuất file báo cáo");
        });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };
  const handleOnDelete = async (id) => {
    setLoading(true);
    try {
      await discountsService.deleteKM(id).then((res) => {
        Notification("success", "Xoá thành công");
        setLoading(false);
      });
    } catch (error) {
      Notification("error", " Xóa nhân viên thất bại");
      setLoading(false);
    }
    getList();
  };
  const handleOnShowDetail = (id) => {
    dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTSADD));
    setIsTabDisabled(false);
    dispatch(setAdd(false));
    dispatch(setEdit(false));
    dispatch(setCCKM(CCKM_MODE.VIEW));
    dispatch(setIdKM(id));
    setIsTabDisabledCT(false);
  };
  const handleEdit = (id) => {
    dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTSADD));
    setIsTabDisabled(false);
    dispatch(setEdit(false));
    dispatch(setAdd(true));
    dispatch(setIdKM(id));
    setIsTabDisabledCT(false);
    dispatch(setCCKM(CCKM_MODE.EDIT));
  };
  
  discountsColumns.map((it) => {
    if (it.dataIndex === "action") {
      it.render = (v, r, i) => {
        return (
          <ListActionButton
            editFunction={() => handleEdit(r.id)}
            showDetailFunction={() => handleOnShowDetail(r.id)}
            deleteFunction={() => handleOnDelete(r.id)}
          />
        );
      };
    }
    if (it.dataIndex === "trangThai") {
      it.render = (v, r, i) => {
        const valueMap = {
          "0": "Chưa kích hoạt",
          "1": "Hiệu lực",
          "2": "Hết hiệu lực",
        };
        const backgroundColors = {
          "Chưa kích hoạt": "#3380FF",
          "Hiệu lực": "#00b335",
          "Hết hiệu lực": "#eb0510",
        };
        const displayValue = valueMap[v] || v;
        const backgroundColor = backgroundColors[displayValue] || "";
        return (
          <div className="color-column" style={{ backgroundColor }}>
            {displayValue}
          </div>
        );
      };
    }
  });
  // useEffect(() => {
  //   fetchListDiscounts({
  //     page: page,
  //     limit: limit,
  //   });
  // }, []);
  useEffect(() => {
    listRef?.current.setFieldValue("ngayBatDau", dayjs());
    listRef?.current.setFieldValue("ngayKetThuc", dayjs());
  }, []);
  const onClickSearchButton = async () => {
    setCurrentPage(1);
    // var searchFields = expandRef?.current?.getData();
    // setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
    const formValue = listRef?.current?.getData();
    const searchFields = {
      ...formValue,
      ngayBatDau: formatDateToString(
        formValue.ngayBatDau,
        FORMAT_TIME.invertDayFull
      ),
      ngayKetThuc: formatDateToString(
        formValue.ngayKetThuc,
        FORMAT_TIME.invertDayFull
      ),
      ngayTaoTu: formatDateToString(
        formValue.ngayTaoTu,
        FORMAT_TIME.invertDayFull
      ),
      ngayTaoDen: formatDateToString(
        formValue.ngayTaoDen,
        FORMAT_TIME.invertDayFull
      ),
    };
    setParams({ ...formValue, ...params, ...searchFields, page: 1 });
  };
  const [columns, setColumns] = useState<any>(discountsColumns);
  columns.map((e) => {
    if (e.dataIndex == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickSearchButton();
    }
  };
  const onAdd = async () => {
    dispatch(setEdit(false));
    dispatch(setIdKM(null));
    dispatch(clearEmployee(false));
    dispatch(setAdd(true));
    dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTSADD));
    setIsTabDisabled(true);
    setIsTabDisabledCT(false);
    dispatch(setCCKM(CCKM_MODE.CREATE));
  };
  const handleView = (id) => {
    dispatch(setActiveKey(tabKeys.CARD_AND_OFFER.DISCOUNTSADD));
    dispatch(setEdit(false));
    dispatch(setIdKM(id));
    dispatch(setAdd(false));
    setIsTabDisabled(false);
    setIsTabDisabledCT(false);
    dispatch(setCCKM(CCKM_MODE.VIEW));
  };
  useEffect(() => {
    columns.map((index) => {
      if (index.dataIndex === "idTrangThai") {
        index.render = (v, r, i) => {
          const valueMap = {
            "0": "Đã gia hạn",
            "1": "Đã xong",
            "2": "Đã đăng",
            "3": "Lên kế hoạch",
          };
          const backgroundColors = {
            "Đã gia hạn": "#3380FF",
            "Đã xong": "#198754",
            "Đã đăng": "#00b335",
            "Lên kế hoạch": "#f00c0c",
          };
          const displayValue = valueMap[v] || v; // Use the mapped value if available, otherwise use the original value
          const backgroundColor = backgroundColors[displayValue] || "";
          return (
            <div className="color-column" style={{ backgroundColor }}>
              {displayValue}
            </div>
          );
        };
      }
    });
  }, []);
  return (
    <Spin spinning={loading}>
      <div className="discounts">
        <div className="container" onKeyDown={onKeyDown}>
          {/* <Form form={form} onFinish={onFinish}> */}
          <Space direction="vertical" style={{ width: "100%" }}>
            <ExpandSearch
              ref={listRef}
              fields={discountsInfo}
              onClickSearch={onClickSearchButton}
              // Ẩn nút "Tìm kiếm nâng cao"
              isSearchExpend={false}
              isResetField={false}
            />
          </Space>
          {/* </Form> */}
        </div>
        <div className="container">
          <Row>
            <Row style={{ marginBottom: "4px" }}>
              <Typography.Text strong>
                Danh mục chương trình ưu đãi
              </Typography.Text>
            </Row>
            <Row justify={"end"} style={{ marginRight: "16px" }}>
              <Space>
                <Button
                  icon={<ExcelSVG />}
                  className="custom-btn"
                  onClick={handelOnExport}
                >
                  Xuất báo cáo
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    onAdd();
                  }}
                >
                  Thêm mới
                </Button>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icon.bars />}
                    className="btn-sub"
                    type="primary"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Space>
            </Row>
            <Row style={{ marginTop: "16px" }}>
              <Table
                loading={loading}
                columns={columns}
                dataSource={discounts ? discounts.data : []}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: discounts?.total,
                  pageSize: discounts?.limit,
                  current: discounts?.page,
                  onChange: onChangePagination,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    onDoubleClick: (e) => handleView(record.id),
                  };
                }}
                bordered
                // rowSelection={{
                //   type: "radio",
                //   // ...rowSelection,
                // }}
              />
            </Row>
          </Row>
          {/* <Row>
            <ListDiscounts ref={listRef} />
          </Row> */}
          {/* <ModalCustom
            ref={listRef}
            width={1600}
            title={`${type} chương trình ưu đãi`}
            centered
          >
            <FormAdd
              data={record}
             // getListApi={getList}
              type={type}
              setCurrentPage={null}
            ></FormAdd>
          </ModalCustom> */}
        </div>
      </div>
    </Spin>
  );
};

export default Discounts;
